import React, { useEffect, useState } from "react";
import Product from "./Product";
import "./Archive.css";
import { requestCanceller } from "../../service/axiosCancelToken";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { getProductArchive } from "../../service/productService";
import toast from "react-hot-toast";
import InfiniteScroll from "react-infinite-scroll-component";
import IconLoading from "../shared/IconLoading";
import LoadingBar from "../shared/EclipseLoading";
import socket from "../../service/socket";
import { Helmet } from "react-helmet";
import ProductDetails from "./ProductDetails";
import { getPosition } from "../../util/ScrollRestoration";

const Archive = () => {
    const [products, setProducts] = useState();
    const [lastProductObj, setLastProductObj] = useState();
    const [hasMore, setHasMore] = useState(true);
    const perPage = window.innerWidth >= 576 ? 25 : 15;
    const { state, pathname } = useLocation();
    const navigate = useNavigate();

    const fetchMoreData = async () => {
        const lastProductObj = {
            priority: products[products.length - 1].priority,
            _id: products[products.length - 1]._id,
        };
        setLastProductObj(lastProductObj);
    };

    useEffect(() => {
        if (!hasMore) return;
        const cancelRequest = requestCanceller();
        const fetchProducts = async () => {
            try {
                const params = {
                    categoryId: state ? state.categoryId : undefined,
                    allProducts: !state
                        ? "yes"
                        : state.categoryName === "همه محصولات"
                          ? "yes"
                          : undefined,
                    perPage: perPage,
                    lastProductObj: lastProductObj
                        ? JSON.stringify(lastProductObj)
                        : undefined,
                    forceActive: true,
                };
                let { status, data } = await getProductArchive(params, {
                    signal: cancelRequest.signal,
                });
                if (status === 201) {
                    setProducts((prev) => {
                        if (
                            !prev ||
                            !prev.length ||
                            (prev.length && !lastProductObj)
                        ) {
                            return data.products;
                        } else {
                            let allproducts = prev.concat(data.products);
                            return allproducts;
                        }
                    });
                    if (data.products.length < perPage) {
                        setHasMore(false);
                    }
                }
            } catch (err) {
                toast.error(err);
            }
        };

        fetchProducts();
        // return () => cancelRequest.cancel();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasMore, lastProductObj]);

    useEffect(() => {
        try {
            socket.on("product", (data) => {
                if (
                    data.action === "create" &&
                    !hasMore &&
                    state &&
                    (state.categoryName === "همه محصولات" ||
                        state.categoryId === data.category._id)
                ) {
                    const prevProducts = [...products];
                    const findIndex = prevProducts.findIndex(
                        (item) => item._id === data.createdProduct._id,
                    );
                    if (findIndex <= -1) {
                        prevProducts.push(data.createdProduct);
                        setProducts(prevProducts);
                    }
                } else if (data.action === "update") {
                    const prevPoducts = [...products];
                    const findIndex = prevPoducts.findIndex(
                        (item) => item._id === data.updatedProduct._id,
                    );
                    if (findIndex > -1) {
                        prevPoducts[findIndex] = data.updatedProduct;
                        setProducts(prevPoducts);
                    }
                } else if (data.action === "delete") {
                    const prevPoducts = [...products];
                    const newProducts = prevPoducts.filter(
                        (item) => item._id !== data.productId,
                    );
                    setProducts(newProducts);
                }
            });
        } catch (err) {}
        return () => socket.off("product");
    }, [products, state, hasMore]);

    useEffect(() => {
        if (pathname === "/products") {
            getPosition("/products");
        }
    }, [pathname]);

    return (
        <div className="all-product-layer">
            <Routes>
                <Route path="/:id" element={<ProductDetails />} />
            </Routes>
            {pathname === "/products" && (
                <React.Fragment>
                    <header className="w-100 search-result">
                        <Helmet>
                            <title>
                                آلماتک | فروشگاه آلماتک |
                                روستابازار زنجان | بازارچه روستابازار زنجان
                            </title>
                            <meta
                                name="description"
                                content={`${"فروش عمده انواع قطعات کولر آبی و لوازم گازسوز و شیر آلات  | تولید کننده انواع دودکش های ساختمانی و ..."}`}
                            />
                        </Helmet>
                        {
                            <h6>
                                <span className="m-0"></span>
                                <section
                                    className=" me-2 text-center"
                                    style={{ width: "40px", cursor: "pointer" }}
                                    onClick={() => navigate(-1)}
                                >
                                    <i className="fa fa-arrow-right text-danger fs-5 "></i>
                                </section>
                                {state && state.categoryName}
                            </h6>
                        }
                    </header>
                    {products && products.length ? (
                        <InfiniteScroll
                            dataLength={products && products.length}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            loader={
                                <div className="d-flex flex-column text-center mt-2 mb-5 mb-sm-2 w-100">
                                    <span className="mx-auto">
                                        {products.length ? (
                                            <IconLoading
                                                type="spin"
                                                color={"#777"}
                                                width={50}
                                                height={50}
                                            />
                                        ) : null}
                                    </span>
                                </div>
                            }
                            endMessage={""}
                        >
                            {products.map((product, index) => (
                                <Product
                                    key={product._id}
                                    _id={product._id}
                                    code={product.code}
                                    name={product.name}
                                    price={product.price}
                                    fakePrice={product.fakePrice}
                                    inventory={product.inventory}
                                    image={product.image}
                                    info={product.info}
                                    incrementalStep={product.incrementalStep}
                                    unit={product.unit}
                                    comeFrom={"archive"}
                                />
                            ))}
                        </InfiniteScroll>
                    ) : (
                        <section
                            style={{
                                height: "60vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {products && !products.length ? (
                                <p className="text-secondary">
                                    موردی برای نمایش وجود ندارد
                                </p>
                            ) : (
                                <LoadingBar classNames={`ldio-text-danger`} />
                            )}
                        </section>
                    )}
                </React.Fragment>
            )}
        </div>
    );
};

export default Archive;
